import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { LoaderService } from 'src/app/service/loader.service';
@Component({
  selector: 'app-mat-dialog',
  templateUrl: './mat-dialog.component.html',
  styleUrls: ['./mat-dialog.component.scss'],
})
export class MatDialogComponent {
  trnID: string;
  textMessage: string;
  fileValueJson: any;
  excelDataAsJson: any;
  inputJsonAPI: any;
  arrayName: any;
  resendCountdown: number = 0;
  resendTimer: any;
  timer!: number;
  remainingTime!: number;
  timeRemaining_percent!: number;
  intervalId: any;
  productId!: string;
  premiumCategoryID!: string;
  reasoninput: any = ''
  allocationErrorss: boolean = false;
  termsChecked : boolean = false;
  constructor(
    public dialogRef: MatDialogRef<MatDialogComponent>,
    public loader: LoaderService,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.textMessage = data.errorMessage;
    this.trnID = data.trnID ? data.trnID : null;
    if (data.yesNoPopup) {
      this.startResendTimer();
    }

  }


  close() {
    this.dialogRef.close(true);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  yesScreen() {
    this.dialogRef.close(false);
  }

  yes() {
    this.dialogRef.close(false);
    if (this.data.yesNoPopup) {
      this.stopCountdownTimer();
    }
    this.dialogRef.close(false);
  }
  CLOSE() {
    this.dialogRef.close('');
  }

  YES() {
    if (this.data.yesNoPopup) {
      this.stopCountdownTimer();
    }
    let val = this.reasoninput.trim();
    if (val !== '') {
      this.dialogRef.close(val);
    } else {
      this.allocationErrorss = true;
    }
  }

  stopCountdownTimer() {
    clearInterval(this.intervalId);
  }

  startResendTimer() {
    this.resendCountdown = 30;
    this.timer = this.resendCountdown;
    this.remainingTime = this.timer;
    this.timeRemaining_percent = (this.remainingTime / this.timer) * 100;
    this.intervalId = setInterval(() => {
      this.remainingTime--;
      this.timeRemaining_percent = (this.remainingTime / this.timer) * 100;
      if (this.remainingTime <= 0) {
        this.stopCountdownTimer();
      }
    }, 1000);
  }
  handleEnteredValue() {
    this.allocationErrorss = false;
  }

}


